export const NOT_FOUND: string = '/404' // Не найдено
export const ROOT: string = '/'
export const LOGIN: string = '/login'

export const CUSTOMER_REGISTRATION: string = '/registration'
export const REGISTRATION_SUCCESS: string = '/success'
